import $ from 'jquery';
import ImageCompare from "image-compare-viewer";

class TWZ_ImageComparison {

	constructor() {
		$(document).ready(() => this.load());
	}

	load() {
		if($('.twz-element-imagecomparison').length) {
			$('.twz-element-imagecomparison').each(function() {
				const viewer = new ImageCompare($(this)[0],{
					showLabels: true,
					smoothing: false,
					labelOptions: {
						before: $(this).data('beforetext'),
						after: $(this).data('aftertext'),
						onHover: false
					},
					// fluidMode: true

				}).mount();
			})

		}
	}
}

new TWZ_ImageComparison